import { useState } from 'react';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { ParcellingTable, type ParcellingTableRow } from '../Tables/ParcellingTable/ParcellingTable';
import styles from './ParcellingPreview.module.css';

export interface ParcellingPreviewProps {
	rows: ParcellingTableRow[];
}

export const ParcellingPreview = ({ rows }: ParcellingPreviewProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleOpen = () => setIsOpen((open) => !open);

	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<button
					type="button"
					className={styles.titleButton}
					onClick={toggleOpen}
					aria-expanded={isOpen}
				>
					<span className={styles.title}>Parcelamento</span>
				</button>
				<button
					type="button"
					className={styles.arrowButton}
					onClick={toggleOpen}
					aria-label={isOpen ? 'Recolher parcelamento' : 'Expandir parcelamento'}
				>
					<KeyboardArrowDown className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`} />
				</button>
			</div>
			<div className={`${styles.body} ${isOpen ? styles.bodyOpen : ''}`}>
				<div className={styles.bodyInner}>
					<ParcellingTable rows={rows} />
				</div>
			</div>
		</div>
	);
};
